import { styled } from 'styled-components';

export const ImageryContent = styled.div`
  min-width: 0;
  width: 100%;
  .imagery-toolbar {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin: 0 0 18px;
    align-items: center;
  }
  .imagery-toolbar .ant-input-search {
    width: 280px;
    max-width: 100%;
  }
  .imagery-toolbar .ant-select {
    min-width: 190px;
    max-width: 100%;
  }
  .imagery-toolbar label {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .imagery-heading {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin: 16px 0 24px;
  }
  .imagery-heading h2 {
    font-size: 22px;
    margin: 0;
    overflow-wrap: anywhere;
  }
  .imagery-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .imagery-detail-grid.imagery-product-detail {
    grid-template-columns: minmax(0, 2fr) minmax(280px, 1fr);
  }
  .imagery-image-pair {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;
    align-items: start;
  }
  .imagery-detail-grid > * {
    min-width: 0;
  }
  .imagery-section {
    padding: 24px 0;
    border-top: 1px solid #e5e8eb;
  }
  .imagery-section h3 {
    font-size: 17px;
    margin: 0 0 16px;
  }
  .imagery-detail-grid {
    display: grid;
    grid-template-columns: minmax(280px, 1fr) minmax(320px, 1.1fr);
    gap: 28px;
    margin-bottom: 24px;
  }
  .imagery-detail-grid h3 {
    font-size: 17px;
    margin: 0 0 16px;
  }
  .imagery-image {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    aspect-ratio: 3 / 2;
    background: #f3f5f7;
    overflow: hidden;
  }
  .imagery-image .ant-image {
    width: 100%;
    height: 100%;
  }
  .imagery-image img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .imagery-thumbnail {
    width: 108px;
    height: 72px;
    flex: none;
  }
  .imagery-image-output {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .imagery-quality-tag {
    max-width: 100%;
    margin-inline-end: 0;
    white-space: normal;
  }
  .imagery-caption {
    font-size: 12px;
    line-height: 18px;
    margin: 8px 0 0;
    color: #56616d;
    overflow-wrap: anywhere;
  }
  .imagery-evidence {
    overflow-wrap: anywhere;
    margin-bottom: 8px;
  }
  .imagery-evidence p {
    margin-bottom: 4px;
  }
  .imagery-suspension-notice {
    max-width: 100%;
    overflow-wrap: anywhere;
    margin-top: 8px;
  }
  .imagery-suspension-notice .ant-tag {
    white-space: normal;
  }
  .imagery-suspension-notice p {
    margin: 8px 0;
  }
  .imagery-record-id {
    font-family: monospace;
    overflow-wrap: anywhere;
  }
  .imagery-candidates {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 24px;
  }
  .imagery-candidate {
    border: 1px solid #e5e8eb;
    border-radius: 4px;
    padding: 16px;
    min-width: 0;
  }
  .imagery-candidate h4 {
    font-size: 15px;
    margin: 0 0 12px;
  }
  .imagery-counts {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    margin-bottom: 24px;
  }
  .imagery-counts dt {
    color: #667380;
    font-size: 12px;
  }
  .imagery-counts dd {
    font-size: 22px;
    margin: 0;
  }
  .ant-table-wrapper {
    max-width: 100%;
  }
  .ant-descriptions-item-content {
    overflow-wrap: anywhere;
  }
  &.imagery-generation-page {
    container-type: inline-size;
    color: ${({ theme }) => theme.textColor};
  }
  .imagery-generation-navigation {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 20px;
  }
  .imagery-generation-navigation > .ant-btn {
    padding-inline: 0;
  }
  .imagery-generation-navigation .ant-breadcrumb {
    min-width: 0;
    font-size: 12px;
    overflow-wrap: anywhere;
  }
  .imagery-generation-heading {
    align-items: center;
    margin: 20px 0 24px;
  }
  .imagery-generation-heading > div {
    min-width: 0;
  }
  .imagery-generation-heading h2 {
    font-size: 25px;
    line-height: 1.3;
    font-weight: 600;
  }
  .imagery-generation-eyebrow {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin: 0 0 8px;
    color: ${({ theme }) => theme.gray};
    font-size: 12px;
  }
  .imagery-generation-eyebrow .imagery-record-id {
    background: ${({ theme }) => theme.white};
    border: 1px solid #e5e8eb;
    border-radius: 4px;
    padding: 2px 6px;
    line-height: 18px;
  }
  .imagery-generation-description {
    margin: 6px 0 0;
    color: ${({ theme }) => theme.gray};
    overflow-wrap: anywhere;
  }
  .imagery-generation-header-actions,
  .imagery-generation-tags {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }
  .imagery-generation-header-actions {
    justify-content: flex-end;
    flex-shrink: 0;
    max-width: 100%;
    gap: 12px;
  }
  .imagery-generation-tags .ant-tag {
    margin: 0;
  }
  .imagery-generation-alert {
    margin-bottom: 20px;
  }
  .imagery-generation-outputs {
    margin-bottom: 20px;
  }
  .imagery-generation-outputs > h3 {
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 12px;
  }
  .imagery-generation-results {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 320px), 1fr));
    gap: 20px;
    align-items: stretch;
  }
  .imagery-generation-result,
  .imagery-generation-panel {
    min-width: 0;
    background: ${({ theme }) => theme.white};
    border: 1px solid #e5e8eb;
    border-radius: 8px;
  }
  .imagery-generation-result {
    padding: 16px;
  }
  .imagery-generation-result-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 6px 12px;
    min-height: 24px;
    margin-bottom: 12px;
  }
  .imagery-generation-result-heading h4 {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
  }
  .imagery-generation-result-heading .imagery-caption {
    margin: 0;
  }
  .imagery-generation-result .imagery-image {
    height: clamp(220px, 25cqw, 300px);
    aspect-ratio: auto;
    background: #f8f9fb;
    border-radius: 6px;
  }
  .imagery-generation-result .imagery-image-output {
    width: 100%;
    gap: 10px;
  }
  .imagery-generation-result .imagery-image-output > .ant-alert {
    width: 100%;
  }
  .imagery-generation-result .imagery-image-output > .imagery-caption {
    margin: 0;
  }
  .imagery-section.imagery-generation-panel {
    margin-top: 20px;
    padding: 20px;
  }
  .imagery-generation-panel > h3 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .imagery-generation-subheading {
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 12px;
  }
  &.imagery-generation-page .ant-descriptions-view > table {
    table-layout: fixed;
  }
  &.imagery-generation-page .ant-descriptions-item-label {
    color: ${({ theme }) => theme.gray};
    font-size: 12px;
  }
  &.imagery-generation-page .ant-descriptions-item-content {
    font-size: 13px;
    min-width: 0;
  }
  &.imagery-generation-page
    .ant-descriptions-vertical
    .ant-descriptions-row
    > th {
    padding-bottom: 4px;
  }
  &.imagery-generation-page
    .ant-descriptions-vertical
    .ant-descriptions-row
    > td {
    padding-bottom: 16px;
  }
  &.imagery-generation-page
    .ant-descriptions-vertical
    .ant-descriptions-row:last-child
    > td {
    padding-bottom: 0;
  }
  &.imagery-generation-page .imagery-candidates {
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 300px), 1fr));
    gap: 16px;
  }
  &.imagery-generation-page .imagery-candidate {
    border-radius: 6px;
  }
  .imagery-generation-candidate-heading {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 16px;
  }
  .imagery-generation-candidate-heading > div {
    min-width: 0;
  }
  .imagery-generation-candidate-heading h4 {
    margin: 0 0 8px;
    font-weight: 600;
  }
  .imagery-generation-score {
    display: flex;
    flex-direction: column;
    gap: 2px;
    text-align: right;
    flex-shrink: 0;
  }
  .imagery-generation-score span {
    font-size: 11px;
    color: ${({ theme }) => theme.gray};
  }
  .imagery-generation-score strong {
    font-size: 20px;
    font-weight: 600;
    line-height: 1.4;
  }
  &.imagery-generation-page .imagery-candidate .imagery-image {
    height: clamp(180px, 20cqw, 230px);
    aspect-ratio: auto;
    background: #f8f9fb;
    border-radius: 4px;
  }
  &.imagery-generation-page
    .imagery-candidate
    .ant-descriptions-item-container {
    flex-wrap: wrap;
    gap: 2px 8px;
  }
  &.imagery-generation-page .imagery-candidate .ant-descriptions-item-label {
    min-width: 105px;
  }
  &.imagery-generation-page .ant-table-wrapper,
  &.imagery-generation-page .ant-table-container {
    min-width: 0;
    max-width: 100%;
  }
  &.imagery-generation-page .ant-table-cell {
    overflow-wrap: anywhere;
    font-size: 12px;
  }
  &.imagery-generation-page .ant-table-thead > tr > th {
    font-weight: 500;
    background: #f8f9fb;
  }
  .imagery-variant-audit > h4 {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 12px;
  }
  @container (max-width: 560px) {
    .imagery-generation-heading {
      align-items: flex-start;
      flex-direction: column;
      gap: 14px;
    }
    .imagery-generation-header-actions {
      width: 100%;
      justify-content: space-between;
    }
    .imagery-section.imagery-generation-panel {
      padding: 16px;
    }
    .imagery-generation-result {
      padding: 12px;
    }
    .imagery-generation-candidate-heading {
      flex-wrap: wrap;
    }
  }
  @media (max-width: 768px) {
    .imagery-detail-grid,
    .imagery-detail-grid.imagery-product-detail,
    .imagery-image-pair,
    .imagery-candidates {
      grid-template-columns: minmax(0, 1fr);
    }
    .imagery-heading {
      flex-wrap: wrap;
    }
    .imagery-toolbar > * {
      max-width: 100%;
    }
  }
`;
